import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = document.getElementById('root')
const preview = document.getElementById('preview')
if (preview && root) {
	root.removeChild(preview)
}

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	root
)

// If you want to start measuring performance in your app, pass a fun
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
